import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DateTimeService} from "../../../services/date-time.service";
import {FormControl, FormGroup} from "@angular/forms";
import {DatePipe} from "@angular/common";
import {Apollo} from "apollo-angular";
import {UPDATE_WAREHOUSE_DATES} from "../sub-statuses/graphql/substatuses";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {AlertService} from "../../../alert/alert.service";

@Component({
    selector: 'warehouse-line',
    templateUrl: './warehouse-line.component.html',
    styleUrls: ['./warehouse-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class WarehouseLineComponent implements OnInit{
  constructor(private dateTime: DateTimeService, private datePipe: DatePipe, private apollo: Apollo, private _snackBar: MatSnackBar) {
  }

  @Input() projectCredits:any[] = [];
  @Input() editMode:boolean = false;
  public forms:any[] = []
  public timezoneList:any[] = []

  ngOnInit() {
    this.timezoneList = this.dateTime.timezones;
    this.renderForms(this.projectCredits)
  }

  public renderForms(outlets:any){
    if(outlets.length > 0){
      for(let i = 0; i < outlets.length; i++){

        if(outlets[i].warehoused==true){
          let timezone = this.timezoneList.find((tz:any) => tz.tz == outlets[i].warehouse_funding_deadline_timezone);
          let options = this.dateTime.intlFormatterOptions;
          if(timezone){
            options.timeZone = timezone.tz
          } else {
            options.timeZone = 'America/New_York'
          }
          let utcBase = null
          if(outlets[i].warehouse_funding_deadline_date!==null && outlets[i].warehouse_funding_deadline_time!==null){
            let dateTime = new Date(outlets[i].warehouse_funding_deadline_date.split("-").join("/") + " " + outlets[i].warehouse_funding_deadline_time.split(".")[0])
            utcBase = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(),dateTime.getDay(), dateTime.getHours(), dateTime.getMinutes()))
          }
          let viewDate = utcBase!==null ? new Intl.DateTimeFormat("en-US", options).format(utcBase) : null;
          let outletName = outlets[i].fund?.name ?? outlets[i].certificatedOutlet?.organization?.name;
          let newForm = new FormGroup({
            name: new FormControl(outletName),
            id: new FormControl(outlets[i].id),
            warehouse_funding_deadline_date: new FormControl(outlets[i].warehouse_funding_deadline_date!==null ? new Date(outlets[i].warehouse_funding_deadline_date.split("-").join("/")): null),
            warehouse_funding_deadline_time: new FormControl(viewDate!==null ? this.datePipe.transform(new Date(viewDate), 'HH:mm:ss') :null),
            warehouse_funding_deadline_timezone: new FormControl(timezone ?? null)
          })
          this.forms.push(newForm)

        }

      }

    }
  }

  public getOutletForm(outlet:any){
    let fundName = outlet.fund?.name ?? outlet.certificatedOutlet?.organization?.name;
    return this.forms.find((form:any) => form.value.name == fundName)
  }

  public renderDateTime(event:any){
    if(event.warehouse_funding_deadline_time==null && event.warehouse_funding_deadline_timezone==null){
      return "--"
    }
    let utctime = event.warehouse_funding_deadline_time.split(".")[0];
    let timezone = this.dateTime.timezones.find((tz:any) => tz.tz === event.warehouse_funding_deadline_timezone)
    let baseDateTime = new Date(event.warehouse_funding_deadline_date + " " + utctime)
    let time = this.dateTime.formatUTCTime(baseDateTime, timezone)

    return time + " " + timezone?.abbr
  }

  public updateWarehouseLine(){
    let savedSolutions:any[] = []
    for(let f = 0; f < this.forms.length; f++){
      let date = this.forms[f].value.warehouse_funding_deadline_date
      let time = this.forms[f].value.warehouse_funding_deadline_time
      let timezone = this.forms[f].value.warehouse_funding_deadline_timezone.tz
      let convertedTime = this.dateTime.convertTimezoneToUTC(this.datePipe.transform(date, 'yyyy-MM-dd') + " " + time, timezone)
      let input = {
        id: this.forms[f].value.id,
        warehouse_funding_deadline_date: this.datePipe.transform(date, 'yyyy-MM-dd'),
        warehouse_funding_deadline_time: convertedTime,
        warehouse_funding_deadline_timezone: timezone
      }
      this._setProjectCredits(input)

      if(!this.forms[f].pristine){
        this.apollo.mutate({
          mutation: UPDATE_WAREHOUSE_DATES,
          variables: {
            id: input.id,
            warehouse_funding_deadline_date: input.warehouse_funding_deadline_date,
            warehouse_funding_deadline_time: input.warehouse_funding_deadline_time,
            warehouse_funding_deadline_timezone: input.warehouse_funding_deadline_timezone
          }
        }).subscribe((response:any) => {
          savedSolutions.push(response.data)
          if(savedSolutions.length == this.forms.length){
            this._openSnackBar();
          }
        })
      }
    }
  }

  private _setProjectCredits(obj:any){
    let credit = this.projectCredits.find((credit:any) => credit.id == obj.id)
    if(credit){
      credit.warehouse_funding_deadline_time = obj.warehouse_funding_deadline_time
      credit.warehouse_funding_deadline_date = obj.warehouse_funding_deadline_date
      credit.warehouse_funding_deadline_timezone = obj.warehouse_funding_deadline_timezone
    }
  }

  private _openSnackBar() {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = 3000;
    this._snackBar.open('Warehouse dates saved successfully.', 'Ok', config);
  }
}
